import React, { Component } from "react";
import "./Welcome.scss";

export default class Welcome extends Component {
    constructor() {
        super();
        this.state = {}
    }
    render() {
        return (
            <section className="section section-welcome">
                <div className="container">
                    <div className="padding">
                        <div className="headlinepromo">
                            <div className="headline">
                                מחפשים דרכים להפוך את הארוחות המשפחתיות לבריאות יותר? <span>גם אנחנו!</span>
                            </div>
                        </div>
                        <div className="desc">
                            הרכיבו מרשימת המרכיבים המופיעה למטה מנה בריאה וטעימה שהילדים שלכם יאהבו לאכול, ספרו לנו מה המתכון ואולי תזכו בפרסים שווים
                        </div>
                        <div className="prize">
                            <div className="line">
                                <span>פרס ראשון</span><span className="linebreak"><br /></span><span className="dash"> - </span> סדנת בישול למשפחה<br />
                            </div>
                            <div className="line">
                                <span>פרס שני</span><span className="linebreak"><br /></span><span className="dash"> - </span> חבילת מוצרי אסם ומנוי חינם ל&quot;ידיעות אחרונות&quot; ל-3 חודשים
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        )
    }
}


// WEBPACK FOOTER //
// ./src/Components/Welcome/Welcome.jsx